import React from "react";
import { Card } from "ui-kit-ck-consultant";
import { Row, Col } from "react-flexbox-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faTrash } from "@fortawesome/free-solid-svg-icons";

const formatSize = (bytes) => `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;

const formatDuration = (seconds) => {
  if (!seconds) return "-";
  const minutes = Math.floor(seconds / 60);
  return `${String(minutes).padStart(2, "0")}:${String(
    seconds % 60
  ).padStart(2, "0")}`;
};

const Record = ({ data, isLoad, deleteRecord }) => {
  const handleDelete = (record) => {
    if (!window.confirm("Supprimer cet enregistrement ?")) return;
    deleteRecord(record.id);
  };

  if (!data.length && !isLoad) return null;

  return (
    <Card title="Enregistrements" className="h-100" isLoader={isLoad}>
      <Row>
        {data.map((element) => (
          <Col key={element.id} xs={12} md={6} lg={4} className="mb-10">
            <div
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <video
                controls
                preload="metadata"
                src={`/api/folder/get-record/${element.id}`}
                style={{ width: "100%", display: "block", backgroundColor: "#000" }}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "8px",
                  padding: "8px 10px",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ fontSize: "13px" }}>
                  <div>{element.date}</div>
                  <div style={{ color: "#6b7280" }}>
                    {formatDuration(element.duration)} · {formatSize(element.size)}
                    {element.status === 2 ? " · Interrompu" : ""}
                  </div>
                </div>
                <div style={{ display: "flex", gap: "8px" }}>
                  <a
                    href={`/api/folder/get-record/${element.id}?download=1`}
                    download={`xpertvisio-${element.id}-${element.token}.webm`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "6px 12px",
                      border: "1px solid #d1d5db",
                      borderRadius: "6px",
                      backgroundColor: "#fff",
                      color: "inherit",
                      fontSize: "13px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload} />
                    Télécharger
                  </a>
                  <button
                    onClick={() => handleDelete(element)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "6px 12px",
                      border: "none",
                      borderRadius: "6px",
                      backgroundColor: "#dc2626",
                      color: "#fff",
                      cursor: "pointer",
                      fontSize: "13px",
                    }}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                    Supprimer
                  </button>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default Record;
